import * as Yup from 'yup';

export const VOUCHER_CODE_MIN_LENGTH = 3;
export const VOUCHER_CODE_MAX_LENGTH = 20;
export const VOUCHER_CODE_REGEX = /^[A-Za-z0-9]{3,20}$/;

export const INVALID_CODE_MESSAGE =
  'Mã voucher từ 3–20 ký tự, chỉ gồm chữ cái và số (không ký tự đặc biệt).';

export const splitCodes = (text) =>
  text
    .split(/[\s,]+/)
    .map((code) => code.trim())
    .filter(Boolean);

const VIETNAMESE_TELEX_MAP = {
  // Lowercase
  á: 'as',
  à: 'af',
  ả: 'ar',
  ã: 'ax',
  ạ: 'aj',
  â: 'aa',
  ấ: 'aas',
  ầ: 'aaf',
  ẩ: 'aar',
  ẫ: 'aax',
  ậ: 'aaj',
  ă: 'aw',
  ắ: 'aws',
  ằ: 'awf',
  ẳ: 'awr',
  ẵ: 'awx',
  ặ: 'awj',
  é: 'es',
  è: 'ef',
  ẻ: 'er',
  ẽ: 'ex',
  ẹ: 'ej',
  ê: 'ee',
  ế: 'ees',
  ề: 'eef',
  ể: 'eer',
  ễ: 'eex',
  ệ: 'eej',
  í: 'is',
  ì: 'if',
  ỉ: 'ir',
  ĩ: 'ix',
  ị: 'ij',
  ó: 'os',
  ò: 'of',
  ỏ: 'or',
  õ: 'ox',
  ọ: 'oj',
  ô: 'oo',
  ố: 'oos',
  ồ: 'oof',
  ổ: 'oor',
  ỗ: 'oox',
  ộ: 'ooj',
  ơ: 'ow',
  ớ: 'ows',
  ờ: 'owf',
  ở: 'owr',
  ỡ: 'owx',
  ợ: 'owj',
  ú: 'us',
  ù: 'uf',
  ủ: 'ur',
  ũ: 'ux',
  ụ: 'uj',
  ư: 'uw',
  ứ: 'uws',
  ừ: 'uwf',
  ử: 'uwr',
  ữ: 'uwx',
  ự: 'uwj',
  ý: 'ys',
  ỳ: 'yf',
  ỷ: 'yr',
  ỹ: 'yx',
  ỵ: 'yj',
  đ: 'dd',

  // Uppercase
  Á: 'AS',
  À: 'AF',
  Ả: 'AR',
  Ã: 'AX',
  Ạ: 'AJ',
  Â: 'AA',
  Ấ: 'AAS',
  Ầ: 'AAF',
  Ẩ: 'AAR',
  Ẫ: 'AAX',
  Ậ: 'AAJ',
  Ă: 'AW',
  Ắ: 'AWS',
  Ằ: 'AWF',
  Ẳ: 'AWR',
  Ẵ: 'AWX',
  Ặ: 'AWJ',
  É: 'ES',
  È: 'EF',
  Ẻ: 'ER',
  Ẽ: 'EX',
  Ẹ: 'EJ',
  Ê: 'EE',
  Ế: 'EES',
  Ề: 'EEF',
  Ể: 'EER',
  Ễ: 'EEX',
  Ệ: 'EEJ',
  Í: 'IS',
  Ì: 'IF',
  Ỉ: 'IR',
  Ĩ: 'IX',
  Ị: 'IJ',
  Ó: 'OS',
  Ò: 'OF',
  Ỏ: 'OR',
  Õ: 'OX',
  Ọ: 'OJ',
  Ô: 'OO',
  Ố: 'OOS',
  Ồ: 'OOF',
  Ổ: 'OOR',
  Ỗ: 'OOX',
  Ộ: 'OOJ',
  Ơ: 'OW',
  Ớ: 'OWS',
  Ờ: 'OWF',
  Ở: 'OWR',
  Ỡ: 'OWX',
  Ợ: 'OWJ',
  Ú: 'US',
  Ù: 'UF',
  Ủ: 'UR',
  Ũ: 'UX',
  Ụ: 'UJ',
  Ư: 'UW',
  Ứ: 'UWS',
  Ừ: 'UWF',
  Ử: 'UWR',
  Ữ: 'UWX',
  Ự: 'UWJ',
  Ý: 'YS',
  Ỳ: 'YF',
  Ỷ: 'YR',
  Ỹ: 'YX',
  Ỵ: 'YJ',
  Đ: 'DD',
};

export const convertVietnameseToTelex = (text) => {
  if (!text) return '';
  return text
    .split('')
    .map((char) => VIETNAMESE_TELEX_MAP[char] || char)
    .join('');
};

export const sanitizeVoucherInput = (raw) => {
  if (!raw) return '';
  const converted = convertVietnameseToTelex(raw);
  return converted
    .replace(/[^A-Za-z0-9]/g, '')
    .slice(0, VOUCHER_CODE_MAX_LENGTH);
};

export const formatVoucherInput = sanitizeVoucherInput;

export const normalizeCode = (code) => sanitizeVoucherInput(code.trim());

export const isValidVoucherCode = (code) => VOUCHER_CODE_REGEX.test(code);

export const toSelectOptions = (codes) =>
  codes.map((code) => ({
    value: code,
    label: code,
  }));

export const voucherCodesValidationSchema = Yup.object({
  codes: Yup.array()
    .min(1, 'Vui lòng nhập ít nhất một mã voucher')
    .test('voucher-format', INVALID_CODE_MESSAGE, (value) =>
      (value || []).every((item) => isValidVoucherCode(item.value)),
    ),
});
